import React from 'react';
import { FadeIn } from './FadeIn';
import { Search, Wind, Salad, Puzzle, User, BookOpen } from 'lucide-react';
export function WhatsInsideSection() {
  const contents = [{
    icon: <Search className="w-6 h-6" data-id="element-201" data-mp="1dvr5yytxucl5" />,
    title: 'Fase 1: Identificar y Desactivar',
    desc: 'Identifica tu perfil (burnout, niebla mental o agotamiento) y aprende las herramientas de emergencia para los días 1 al 7.'
  }, {
    icon: <Wind className="w-6 h-6" data-id="element-202" data-mp="1mve5tg70rac3" />,
    title: 'El suspiro fisiológico de Stanford',
    desc: 'Una práctica breve de respiración estructurada estudiada por Stanford para apoyar el estado de ánimo y la regulación fisiológica.'
  }, {
    icon: <Salad className="w-6 h-6" data-id="element-203" data-mp="1rvsen0gg2ob6" />,
    title: 'Fase 2: Nutrir el Cuerpo que Piensa',
    desc: 'Microbiota, movimiento, sueño y nutrición como apoyo para tu bienestar mental (días 8 al 14).'
  }, {
    icon: <Puzzle className="w-6 h-6" data-id="element-204" data-mp="3tnoqkb6iy06h" />,
    title: 'Fase 3: Reprogramar la Mente',
    desc: 'TCC simplificada, defusión cognitiva y vínculos que sanan para los días 15 al 21.'
  }, {
    icon: <User className="w-6 h-6" data-id="element-205" data-mp="3ieswwk7ks2kt" />,
    title: 'Capítulo especial: Burnout maternal',
    desc: 'Para mujeres latinas que cargan con todo y no tienen permiso de estar agotadas.'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-206" data-mp="3s5nkpt0gza8d" />,
    title: 'Referencias científicas completas',
    desc: 'Incluye referencias científicas y citas al final de la guía.'
  }];
  return <section className="py-20 bg-brand-cream" data-id="element-207" data-mp="5xnkji3s19n4">
      <div className="max-w-6xl mx-auto px-6" data-id="element-208" data-mp="5wchjki5o5x2">
        <FadeIn data-id="element-209" data-mp="9zqyqehtysc3">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-210" data-mp="9yzbps2au2xf">
            ¿Qué encontrarás en esta guía?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-211" data-mp="2br422z45gs61">
          {contents.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-212" data-mp="2gp5mpoh84zjm" data-mpi={index}>
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 h-full border border-transparent hover:border-brand-sage hover:border-opacity-30" data-id="element-213" data-mp="2grs40ftx2tf1">
                <div className="w-12 h-12 bg-brand-light-sage text-brand-forest rounded-xl flex items-center justify-center mb-6" data-id="element-214" data-mp="3t1j95xlof7kn">
                  {item.icon}
                </div>
                <h3 className="font-serif font-bold text-xl text-brand-charcoal mb-3" data-id="element-215" data-mp="3o4sthbdsadzr">
                  {item.title}
                </h3>
                <p className="text-brand-gray leading-relaxed" data-id="element-216" data-mp="1w1c4uo8qi7r">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}